import { PayloadAction } from '@reduxjs/toolkit';
import { FundDetailsState } from '@/store/fundDetails/typings';

export const fundDetailsReducer = {
  setSelectedShareClassIsin(state: FundDetailsState, { payload }: PayloadAction<string>) {
    state.selectedShareClassIsin = payload;
  },
  setFundDetailsData(state: FundDetailsState, { payload }: PayloadAction<any>) {
    state.formJson = payload.formJson;
    state.availableTabs = payload.availableFundDetailsTabs;
    state.shareClasses = payload.shareClasses;
    state.name = payload.name;
    state.fundId = payload.id;
    state.correlationFundRangeID = payload.correlationFundRangeID;
    state.fundRangeName = payload.fundRangeName;
    state.selectedShareClass = payload.selectedShareClass;
    state.assetClassId = payload.assetClassId;
    state.isFundDetailsImportantInfoAvailable = payload.isImportantInfoAvailable;
    state.sfdrClassificationId = payload.sfdrArticleClassificationId;
    state.assetClassName = payload.assetClassName;
    state.subAssetClassName = payload.subAssetClassName;
    state.shareClassNameId = payload.shareClassNameId;
    state.fundNameId = payload.fundNameId;
    state.fundHeroType = payload.fundHeroType;
  },
  setIsFundDetailsLoading(state: FundDetailsState, { payload }: PayloadAction<boolean>) {
    state.isLoading = payload;
  },
};
